import { createI18n } from "vue-i18n"
import plCommon from "./locales/pl/common.json"
import plAuth from "./locales/pl/auth.json"
import plDashboard from "./locales/pl/dashboard.json"
import plOrders from "./locales/pl/orders.json"
import plMenu from "./locales/pl/menu.json"
import plSettings from "./locales/pl/settings.json"
import plValidation from "./locales/pl/validation.json"
import plOrderDetails from "./locales/pl/orderDetails.json"
import plProducts from "./locales/pl/products.json"
import plMenuTranslations from "./locales/pl/menuTranslations.json"
import plAdmin from "./locales/pl/admin.json"
import enCommon from "./locales/en/common.json"
import enAuth from "./locales/en/auth.json"
import enDashboard from "./locales/en/dashboard.json"
import enOrders from "./locales/en/orders.json"
import enMenu from "./locales/en/menu.json"
import enSettings from "./locales/en/settings.json"
import enValidation from "./locales/en/validation.json"
import enOrderDetails from "./locales/en/orderDetails.json"
import enProducts from "./locales/en/products.json"
import enMenuTranslations from "./locales/en/menuTranslations.json"
import enAdmin from "./locales/en/admin.json"

const messages = {
  pl: {
    common: plCommon,
    auth: plAuth,
    dashboard: plDashboard,
    orders: plOrders,
    menu: plMenu,
    settings: plSettings,
    validation: plValidation,
    orderDetails: plOrderDetails,
    products: plProducts,
    menuTranslations: plMenuTranslations,
    admin: plAdmin,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    orders: enOrders,
    menu: enMenu,
    settings: enSettings,
    validation: enValidation,
    orderDetails: enOrderDetails,
    products: enProducts,
    menuTranslations: enMenuTranslations,
    admin: enAdmin,
  },
}

// Get language from localStorage or default to 'pl'
const getDefaultLocale = (): string => {
  const stored = localStorage.getItem("app_language")
  if (stored && (stored === "pl" || stored === "en")) {
    return stored
  }
  // Try to detect from browser
  const browserLang = navigator.language.split("-")[0]
  if (browserLang === "en") {
    return "en"
  }
  return "pl"
}

export const i18n = createI18n({
  legacy: false,
  locale: getDefaultLocale(),
  fallbackLocale: "pl",
  messages,
})

export default i18n
